export default "__VITE_ASSET__Da2gUT6K__"